var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"actual flex-auto d-flex"},[_c('Trello',{attrs:{"issues":_vm.issues,"statuses":_vm.statuses}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }